import {defaultSettings} from './default'
import {customerSettings} from "./customer";
import {merge} from 'lodash';

const settings = merge(defaultSettings, customerSettings);
export default settings;
